import {createGlobalStyle} from 'styled-components';
import reset from 'styled-reset';
import {minmax} from 'utils/minmax';

const GlobalStyles = createGlobalStyle`
  ${reset}
  a{
    text-decoration: none;
    color: inherit;
  }
  *{
    box-sizing: border-box;
  }
  html, body, div, span, h1, h2, h3, h4, h5, h6, p, 
  a, dl, dt, dd, ol, ul, li, form, label, table{
    margin: 0;
    padding: 0;
    border: 0;
    font-size: 10px;
    vertical-align: baseline;
  }
  body{
    font-family: 'Noto Sans KR', sans-serif;
    line-height: 1;
    background-color: #ffffff;
    margin: 0;
     padding: 0;
      overflow: hidden;

    // iuput type number 의 화살표 제거
    /* Works for Chrome, Safari, Edge, Opera */
    input::-webkit-outer-spin-button,
    input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
    /* Works for Firefox */
    input[type=number] {
    -moz-appearance:textfield;
  }
}
  ol, ul{
    list-style: none;
}
  button {
    border: 0;
    background: transparent;
    cursor: pointer;
}
  #root {
    height: calc(var(--vh, 1vh) * 100);
    overflow: auto;
}
  input{
    margin: 0;
    padding: 0;
  }

`;

export default GlobalStyles;
